var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDelete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 428.75,
    height: 446.24,
    viewBox: "0 0 428.75 446.24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "delete",
    transform: "translate(-135.62 -56.88)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_103",
    "data-name": "Path 103",
    d: "M555.62,126.88H144.37a8.75,8.75,0,0,1,0-17.5H555.62a8.75,8.75,0,0,1,0,17.5Z",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_104",
    "data-name": "Path 104",
    d: "M406.88,126.88H284.38a8.751,8.751,0,0,1-8.75-8.75,61.254,61.254,0,0,1,61.25-61.25h17.5a61.254,61.254,0,0,1,61.25,61.25,8.749,8.749,0,0,1-8.75,8.75ZM294,109.38H397.25a43.923,43.923,0,0,0-42.875-35h-17.5a43.923,43.923,0,0,0-42.875,35Z",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_105",
    "data-name": "Path 105",
    d: "M345.62,441.88a8.751,8.751,0,0,1-8.75-8.75v-245a8.75,8.75,0,0,1,17.5,0v245a8.749,8.749,0,0,1-8.75,8.75Z",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_106",
    "data-name": "Path 106",
    d: "M415.62,441.88a8.751,8.751,0,0,1-8.051-9.273l17.5-245a8.924,8.924,0,0,1,9.277-8.051,8.745,8.745,0,0,1,8.047,9.273l-17.5,245a8.748,8.748,0,0,1-9.273,8.051Z",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107",
    "data-name": "Path 107",
    d: "M275.62,441.88a8.751,8.751,0,0,1-8.75-8.051l-17.5-245a8.751,8.751,0,0,1,8.051-9.273,8.923,8.923,0,0,1,9.273,8.051l17.5,245a8.748,8.748,0,0,1-8.051,9.273Z",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108",
    "data-name": "Path 108",
    d: "M406.52,503.12H284.02a78.92,78.92,0,0,1-78.047-68.773l-35.875-280a8.746,8.746,0,0,1,7.523-9.8,8.926,8.926,0,0,1,9.8,7.523l35.875,280a61.428,61.428,0,0,0,60.723,53.375h122.5a61.426,61.426,0,0,0,60.727-53.2l35.875-280a8.923,8.923,0,0,1,9.8-7.523,8.744,8.744,0,0,1,7.523,9.8l-35.875,280a78.926,78.926,0,0,1-78.051,68.6Z",
    fill: "#010101"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.c2e03ef1efe2882fb027c1048b7c6b49.svg";
export { ForwardRef as ReactComponent };